import React from 'react'
import PropTypes from 'prop-types'
import SydModal from '../../../../commonDesign/SydModal'
import { useGetSyncedTransactionById } from '../../../../../api/coreData'
import TransactionDetailView from './TransactionDetailView'

export default function TransactionDetailModal ({ open, onClose, transactionId }) {
  const { data: result, isLoading } = useGetSyncedTransactionById(transactionId, {
    enabled: open && !!transactionId
  })

  return (
    <SydModal
      title='Transaction Detail'
      open={open}
      onClose={onClose}
      size='large'
      style={{ maxHeight: '80vh', overflow: 'auto' }}
    >
      <TransactionDetailView
        data={result?.data}
        displayMeta={result?.displayMeta}
        isLoading={isLoading}
        layout='wide'
      />
    </SydModal>
  )
}

TransactionDetailModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  transactionId: PropTypes.number
}
